import { useAuth0 } from "@auth0/auth0-react";
import { useMemo } from "react";

export const AUTH0_NAMESPACE =
  import.meta.env.VITE_AUTH0_NAMESPACE || "https://app.forcemx.io";

type AuthUser = {
  email?: string;
  [key: string]: unknown;
};

/** Resolve the tenant carried by the authenticated identity. */
export function getTenantIdFromUser(user?: AuthUser | null): string | null {
  if (!user) return null;

  const claim = user[`${AUTH0_NAMESPACE}/tenant_id`];
  if (typeof claim === "string" && claim.trim()) return claim.trim();

  const emailDomain = user.email?.split("@")[1]?.trim().toLowerCase();
  return emailDomain ? emailDomain.replace(/[._]/g, "-") : null;
}

export function useTenantId(): string | null {
  const { user, isAuthenticated } = useAuth0();
  return useMemo(
    () => (isAuthenticated ? getTenantIdFromUser(user as AuthUser | undefined) : null),
    [isAuthenticated, user],
  );
}
